export type SingleCorpAccount = {
	accountId: string;
	accountName: string;
	documentId: number;
	adminsCount: number;
	documentType: types.organizations.documentType;
};

const model: types.models.InputModel = {
	accountId: 'accountId',
	accountName: 'accountName',
	documentId: 'documentId',
	adminsCount: 'adminsCount',
	documentType: 'documentType',
};

export default model;
